export default function isString(value) {
    return typeof value === "string";
}


//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/common/is-string.js
// module id = 235
// module chunks = 93